import { useInfiniteQuery } from '@tanstack/react-query'

import API from '../../../utils/api'

export const RANGE_OPTIONS = [
  { value: 'all', label: 'Todo' },
  { value: 'today', label: 'Hoy' },
  { value: 'week', label: 'Esta semana' },
  { value: 'month', label: 'Este mes' },
  { value: 'semester', label: 'Este semestre' },
]

export const useCasinoRounds = (range = 'all') => {
  const query = useInfiniteQuery(
    ['casino-rounds', range],
    ({ pageParam = 1 }) =>
      API.getPPCasinoRounds({
        page: pageParam,
        range,
        pages: 1,
        replaceList: true,
      }),
    {
      getNextPageParam: (lastPage) => {
        const { page, pages } = lastPage.data
        return page < pages ? page + 1 : undefined
      },
      keepPreviousData: true,
    }
  )

  const rounds = query.data?.pages.flatMap((page) => page.data.rounds ?? []) ?? []

  return {
    rounds,
    isLoading: query.isLoading,
    isFetchingNextPage: query.isFetchingNextPage,
    hasNextPage: query.hasNextPage,
    fetchNextPage: query.fetchNextPage,
    error: query.error,
    refetch: query.refetch,
  }
}
